import React from 'react';
import Layout from '../components/layout/Layout';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { AlertCircle, Mail, RefreshCw, CreditCard } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

const AccessBlocked = () => {
  const { user } = useAuth();
  const handleRefresh = () => {
    window.location.reload();
  };
  
  const handleRenewal = () => {
    window.location.href = '/subscription-lifecycle/renew';
  };
  
  // Skip AccessBlocked for DEFAULT_INSTITUTE_ID users
  if (user?.institute_id === parseInt(process.env.REACT_APP_DEFAULT_INSTITUTE_ID || '1')) {
    return <div>Loading...</div>; // This should not happen, but just in case
  }
  
  return (
    <Layout>
      <div className="container mx-auto p-6 max-w-2xl">
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
          <Card className="w-full">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-red-600" />
              </div>
              <CardTitle className="text-2xl text-red-600">Access Deactivated</CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-6">
              <div className="space-y-4">
                <p className="text-muted-foreground">
                  Your institute's subscription has expired and your account has been temporarily deactivated.
                </p>
                {user?.role === 'admin' ? (
                  <p className="text-muted-foreground">
                    As an administrator, you can renew the subscription to restore access for all users.
                  </p>
                ) : (
                  <p className="text-muted-foreground">
                    Please contact your institute administrator to renew the subscription and restore access.
                  </p>
                )}
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                {user?.role === 'admin' && (
                  <Button onClick={handleRenewal} className="flex items-center gap-2">
                    <CreditCard className="w-4 h-4" />
                    Renew Subscription
                  </Button>
                )}
                <Button variant="outline" onClick={handleRefresh} className="flex items-center gap-2">
                  <RefreshCw className="w-4 h-4" />
                  Check Again
                </Button>
              </div>
              
              {user?.role !== 'admin' && (
                <div className="pt-4 border-t">
                  <p className="text-sm text-muted-foreground mb-2">Need help? Contact support:</p>
                  <Button variant="ghost" size="sm" className="flex items-center gap-2 mx-auto">
                    <Mail className="w-4 h-4" />
                    support@navipro.com
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default AccessBlocked;
